import { RegionShared } from "@1games-ru/region-shared";
import { InventoryOwnerType } from "@1games-ru/region-shared/dist/enums/inventory/inventory";
import { Inventory } from "@1games-ru/region-shared/dist/types/inventory/inventory";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { OwnerType } from "@/domains/inventory/constants/ownerType";
import { IS_DEV } from "@/domains/main/constants/other";
import { reset, setInventory, setTrade } from "@/domains/inventory/slice";
import { playerInfoSelector } from "@/domains/player/slice";
import useTradeManager from "@/domains/inventory/hooks/trade/useTradeManager";
import useGetInventory from "@/domains/inventory/hooks/useGetInventory";

export default function useShowTrade() {
  const playerInfo = useAppSelector(playerInfoSelector);
  const [isShowTrade, setIsShowTrade] = useState(false);
  const { getTradeState } = useTradeManager();
  const { getInventory } = useGetInventory();
  const dispatch = useAppDispatch();

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Inventory.ShowTrade,
      (data: typeof RegionShared.Cef.Requests.ShowTradeRequest) => {
        dispatch(reset());
        if (data) {
          dispatch(setTrade(data));
          getInventory({
            inventoryOwnerId: String(playerInfo.character.id),
            inventoryOwnerType: InventoryOwnerType.Character,
          });
          dispatch(
            setInventory({
              ...data.initiator.inventory,
              ownerType: OwnerType.Trade,
            } as unknown as Inventory),
          );
          dispatch(
            setInventory({
              ...data.recipient.inventory,
              ownerType: OwnerType.Trade,
            } as unknown as Inventory),
          );
        } else {
          dispatch(reset());
        }
        setIsShowTrade(true);

        return true;
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Inventory.ShowTrade);
    };
  }, [playerInfo]);

  useEffect(() => {
    rpc.register(
      RegionShared.Cef.Events.Observer.NotifyTradeUpdated,
      async (data: { tradeId: number }) => {
        await getTradeState({ tradeId: Number(data.tradeId) });
        return true;
      },
    );

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Observer.NotifyTradeUpdated);
    };
  }, [getTradeState]);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Inventory.HideTrade, () => {
      setIsShowTrade(false);
      dispatch(reset());
      return true;
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Inventory.HideTrade);
    };
  }, []);

  return {
    isShowTrade: !!(isShowTrade || IS_DEV),
  };
}
